import api from './api.service';
import type {
  User,
  CreateUserRequest,
  UpdateUserRequest,
  ResetPasswordRequest,
} from '@/types/user.types';

// === USERS API ===

export const usersApi = {
  /**
   * Lista todos os usuários (apenas admin)
   */
  getAll: async (): Promise<User[]> => {
    const { data } = await api.get<User[]>('/api/users');
    return data;
  },

  /**
   * Busca um usuário por ID (apenas admin)
   */
  getById: async (id: number): Promise<User> => {
    const { data } = await api.get<User>(`/api/users/${id}`);
    return data;
  },

  /**
   * Cria um novo usuário (apenas admin)
   */
  create: async (userData: CreateUserRequest): Promise<User> => {
    const { data } = await api.post<User>('/api/users', userData);
    return data;
  },

  /**
   * Atualiza um usuário (apenas admin)
   */
  update: async (id: number, userData: UpdateUserRequest): Promise<User> => {
    const { data } = await api.put<User>(`/api/users/${id}`, userData);
    return data;
  },

  /**
   * Deleta um usuário (apenas admin)
   */
  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/users/${id}`);
  },

  /**
   * Reseta a senha de um usuário (apenas admin)
   */
  resetPassword: async (id: number, resetData: ResetPasswordRequest): Promise<void> => {
    await api.post(`/api/users/${id}/reset-password`, resetData);
  },
};
